<div class="container" style="max-width: 100%;">
    <H1>View Audit Log</H1>

    <div class="row">

      <div class="col-4" style="text-align: left;" > 
        <label>Search Box Number:</label>
        <div class="input-group mb-3">
          <input class="form-control" ID="details" name="details" type="text" [(ngModel)]="SearchValue.Boxno" placeholder="Input a Box number" (ngModelChange)="Search()"/>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary btnClear" type="button" id="button-addon2" (click)="ClearBoxNoSearch()">X</button>
          </div>
        </div>
        <div>
          <button class="btn btn-warning" type="button" id="button-addon2" (click)="ClearSearch()">Clear Search</button>
          <button class="btn btn-success" type="button" id="button-addon2" (click)="btnDownloadReportClickExcel()" style="margin-left: 5%;">Export</button>
        </div>
      </div>
    </div>
  

   

    <table class="viewDataTable" ID="tblData">
      <thead>
        <tr>
          <th class="viewDataTableHeading">Box Number</th>
          <th class="viewDataTableHeading">Deleted By</th>
          <th class="viewDataTableHeading">Deleted Date</th>
        </tr>
      </thead>

        <tr *ngFor="let DisplayData of data | paginate: { itemsPerPage: ItemsPerPage, currentPage: p }">
            <td class="viewDataTableCell">{{DisplayData.Boxno}}</td>
            <td class="viewDataTableCell">{{DisplayData.DeletedBy}}</td>
            <td class="viewDataTableCell">{{DisplayData.DeletedDate}}</td>
        </tr>

        <tr *ngIf="data.length <= 0">
          <td class="viewDataTableCell" colspan="13">No records found, please refine your search and try again.</td>
        </tr>

      </table>

      <pagination-controls (pageChange)="p = $event"></pagination-controls>

        <button class="btn btn-info" type="button" id="btnLoadMore" (click)="LoadMoreFields()"  *ngIf="data.length === iRowsLoaded">Load More</button>

</div>

<!--Error popup-->
<div style="float: right;margin-left:20px;">
  <button class="btn btn-success btn-lg btn-block" id="ErrorButton" (click)="open(content)" style="display: none;">
  </button>
</div>
<ng-template #content let-modal ID="Errormessage">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{PopupTitle}}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">

      <span aria-hidden="true">

      </span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="dateOfBirth">
          {{DisplayErrormessage}}
        </label>
      </div>


    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success btn-lg btn-block" (click)="modal.close('Save click')">
      Done
    </button>


  </div>
</ng-template>